"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = ContentImage;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _emotion = require("emotion");

var _classnames = _interopRequireDefault(require("classnames"));

var _BadgeCertificateIcon = _interopRequireDefault(require("./BadgeCertificateIcon"));

var _isCompleted = _interopRequireDefault(require("../utils/isCompleted"));

var _isFailedContent = _interopRequireDefault(require("../utils/isFailedContent"));

var _isPendingReview = _interopRequireDefault(require("../utils/isPendingReview"));

var _LockIcon = _interopRequireDefault(require("./LockIcon"));

var s = {
  imageContainer: function imageContainer(height, width) {
    return (
      /*#__PURE__*/
      (0, _emotion.css)("position:relative;height:", height, "px;width:", width, "px;border-radius:4px;")
    );
  },
  image: function image(height, width) {
    return (
      /*#__PURE__*/
      (0, _emotion.css)("position:absolute;top:0;left:0;right:0;bottom:0;border-radius:4px;height:", height, "px;width:", width, "px;")
    );
  },
  imageContentContainer: function imageContentContainer(showCertBadge, showOverlay) {
    return (
      /*#__PURE__*/
      (0, _emotion.css)("position:absolute;top:0;left:0;right:0;bottom:0;z-index:2;border-radius:4px;display:flex;justify-content:center;align-items:center;background-image:", showCertBadge ? 'radial-gradient(circle at 50% 50%, rgba(18, 21, 25, 0.65), #000000)' : showOverlay ? 'radial-gradient(circle at 50% 50%, rgba(18, 21, 25, 0), rgba(0, 0, 0, 0.68))' : 'none', ";")
    );
  }
};

function ContentImage(props) {
  var name = props.name,
      image = props.image,
      certificateInfo = props.certificateInfo,
      badgeInfo = props.badgeInfo,
      badgeIconSize = props.badgeIconSize,
      height = props.height,
      width = props.width,
      className = props.className,
      showOverlay = props.showOverlay,
      isNotAvailable = props.isNotAvailable;
  var hasCertificateOrBadge = certificateInfo || badgeInfo;
  var completed = (0, _isCompleted.default)(props);
  var isFailed = (0, _isFailedContent.default)(props);
  var pendingReview = (0, _isPendingReview.default)(props);
  var resizedImage = "https://res.cloudinary.com/lyearn/image/fetch/w_".concat(width, ",h_").concat(height, ",c_fill/").concat(image);
  return _react.default.createElement("div", {
    className: (0, _classnames.default)(s.imageContainer(height, width), className)
  }, _react.default.createElement("img", {
    src: resizedImage,
    alt: name,
    className: s.image(height, width)
  }), isNotAvailable && _react.default.createElement(_LockIcon.default, null), _react.default.createElement("div", {
    className: s.imageContentContainer(completed && !isFailed && hasCertificateOrBadge, showOverlay)
  }, !isFailed && !pendingReview && _react.default.createElement(_BadgeCertificateIcon.default, (0, _extends2.default)({}, props, {
    size: badgeIconSize
  }))));
}